/**
 * Created by Ethan on 17/3/11.
 */
import monent from 'moment';
import * as DateTimeFormats from "../constants/DateTimeFormats";
// 日期格式化
Date.prototype.format = function (format) {
    var o = {
        "M+": this.getMonth() + 1, //month
        "d+": this.getDate(),   //day
        "h+": this.getHours(),  //hour
        "m+": this.getMinutes(), //minute
        "s+": this.getSeconds(), //second
        "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
        "S": this.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
        (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1,
            RegExp.$1.length == 1 ? o[k] :
                ("00" + o[k]).substr(("" + o[k]).length));
    return format;
}


// 日期格式化
export const DateTimeFormat = {


    dateToHyphenString: (date) => {
        if (date) {
            return monent(date, DateTimeFormats.FORMAT_DATE_SIMPLE).format(DateTimeFormats.FORMAT_DATE_HYPHEN);
        }
        return ''
    },
    dateToZHString: (date) => {
        if (date) {
            return monent(date, DateTimeFormats.FORMAT_DATE_SIMPLE).format(DateTimeFormats.FORMAT_DATE_ZH);
        }
        return ''
    },
    datetimeToHyphenString: (datetime) => {
        if (datetime) {
            return monent(datetime, DateTimeFormats.FORMAT_DATE_TIME_SIMPLE).format(DateTimeFormats.FORMAT_DATE_TIME_HYPHEN);
        }
        return ''
    },
    timeToString: (time) => {
        if (time) {
            return monent(time, DateTimeFormats.FORMAT_DATE_SIMPLE).format(DateTimeFormats.FORMAT_TIME_COLON);
        }
        return ''
    },
    yearMonthToZHString: (date) => {
        if (date) {
            return monent(date, DateTimeFormats.FORMAT_DATE_SIMPLE).format(DateTimeFormats.FORMAT_DATE_YEAR_MONTH_ZH);
        }
        return ''
    },
    datetimeToHyphenMinuteString: (date) => {
        if (date) {
            return monent(date, DateTimeFormats.FORMAT_DATE_TIME_SIMPLE).format(DateTimeFormats.FORMAT_DATE_TIME_MINUTE_HYPHEN);
        }
        return ''
    },
}